import(/* webpackMode: "eager", webpackExports: ["TopLoadingBarIndicator"] */ "/vercel/path0/packages/ui/src/makerkit/top-loading-bar-indicator.tsx");
